import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=280475c3&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280475c3')) {
      api.createRecord('280475c3', component.options)
    } else {
      api.reload('280475c3', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=280475c3&", function () {
      api.rerender('280475c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2twYD7uYoT5DR/JS/cancellationPolicy.vue"
export default component.exports